import { useState, useEffect, useContext } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import ETradeAuthorization from "../auth/ETradeAuthorization";

const VerifyTrade = () => {
    // const [loading, setLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    const [address, setAddress] = useState('');
    const {etradeAuthCallback, etradeAllAcc, thirdParyAccount, holdingsData, getOrderData, userData, eTradeAuth, setEtradeAuthData, accountsSummary, getWatchLists, preformanceData, handleCloseEtradeAuth, fetchUserData} = useContext(AuthContext);
    const navigate = useNavigate();
    const [etradeAuth, setEtradeAuth] = useState(false);

    // useEffect(() => {
    //     setTimeout(() => setLoading(false), 40000);
    // }, []);

    const handleOpenEtradeAuth = () => setEtradeAuth(true);

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleAddressSubmit = async (event) => {
        event.preventDefault();
        setLoading(false)

        const resource_owner_key = localStorage.getItem('resource_owner_key');
        const resource_owner_secret = localStorage.getItem('resource_owner_secret');

        try{
            const response = await etradeAuthCallback('etrade', address, resource_owner_key, resource_owner_secret);
            console.log(response);
            if(response.message === 'Authorization successful! You can now make API calls.'){
                localStorage.setItem('xAccessToken', response.access_token);
                localStorage.setItem('xAccessTokenSecret', response.access_token_secret);
                handleCloseEtradeAuth(); // Close the ETradeAuthorization popup
                
                // Refresh user data to update thirdParyAccount in context
                await fetchUserData(true);
                
                navigate('/Home/Landing');
                if(!userData?.integrations?.trade_account_id){
                    await etradeAllAcc();
                }
                else{
                    await holdingsData(thirdParyAccount, userData?.integrations?.trade_account_id);
                    await getOrderData(thirdParyAccount, userData?.integrations?.trade_account_id);
                    await getWatchLists(thirdParyAccount, userData?.integrations?.trade_account_id);
                    await preformanceData(thirdParyAccount, userData?.integrations?.trade_account_id, '1D');
                    await accountsSummary(thirdParyAccount, userData?.integrations?.trade_account_id, userData?.integrations?.trade_ins_type);
                }
            }
            else{
                const response = await eTradeAuth('etrade');
                setEtradeAuthData(response);
                localStorage.setItem('resource_owner_key', response.resource_owner_key);
                localStorage.setItem('resource_owner_secret', response.resource_owner_secret);
                handleOpenEtradeAuth();
            }
        }
        catch(error){
            console.log('failed to login');
            return null;
        }
        
    };

    return (
        <>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                {/* {loading ? (
                    <div className="loaderContainerStyle">
                        <div className="loaderStyle"></div>
                        <div className="textStyle">Redirecting to the Homepage ...</div>
                    </div>
                ) : (
                    <h2>Data Loaded</h2>
                )} */}
                <div className="login-container">
                    <Card className="login-card gradient-border">
                        <Card.Body>
                            <Form onSubmit={handleAddressSubmit}>
                                <div className="mb-2">
                                    <span style={{fontSize: "16px", color:'white'}}>Enter Code</span>
                                </div>
                                <Form.Group controlId="formBasicEmail" className="control">
                                    <Form.Control
                                        type="text"
                                        className="form-input"
                                        placeholder=" "
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    />
                                </Form.Group>

                                <div>
                                    <Button 
                                        variant="primary" 
                                        type="submit" 
                                        className="mt-3 w-100 p-2 theme-btn"
                                        disabled={loading} // Disable button if loading
                                    >
                                        {loading ? "Submitting..." : "Submit"} {/* Change button text based on loading state */}
                                    </Button>
                                </div>
                                <div className="mt-3">
                                    <Button 
                                        variant="outline-light" 
                                        type="button" 
                                        className="w-100 p-2 go-back-btn"
                                        onClick={handleGoBack}
                                        style={{ 
                                            borderColor: '#48494C', 
                                            color: '#FFFFFF',
                                            textTransform: 'none'
                                        }}
                                    >
                                        Go Back
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
            </div>
            <ETradeAuthorization open={etradeAuth} onClose={handleCloseEtradeAuth}/>
        </>
        
    );
};

export default VerifyTrade;
